import styled, { css, keyframes } from 'styled-components';

import { PaletteColor, SizeUnit } from '@utils/types';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const ModalWrapper = styled.div<{
  zIndex?: number;
}>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${(p) => (p.zIndex ? p.zIndex : 1000)};
  animation: ${fadeIn} 0.1s ease-in;
`;

export const ModalContent = styled.div<{
  width?: number | SizeUnit | string;
  height?: number | SizeUnit;
  $headerMediaQuery?: string;
  backgroundColor?: PaletteColor;
  padding?: SizeUnit;
  isPhoneFullHeight?: boolean;
  borderRadius?: number;
}>`
  border-radius: ${(p) => (p.borderRadius ? p.borderRadius : 0)}px;
  background-color: ${(p) =>
    p.backgroundColor
      ? p.theme.palette[p.backgroundColor]
      : p.theme.palette.white};
  height: ${(props) =>
    typeof props.height === 'number'
      ? `${props.height}px`
      : props.height || 'auto'};
  max-height: 100%;
  width: ${(props) =>
    typeof props.width === 'number'
      ? `${props.width}px`
      : props.width || 'auto'};
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: ${(p) => (p.padding ? p.padding : '40px')};
  overflow-y: auto;
  scrollbar-width: thin;
  /* For WebKit based browsers */
  &::-webkit-scrollbar {
    width: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 3px;
  }
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    position: relative;
    padding: ${(p) => (p.padding ? p.padding : '20px')};
    border-radius: ${(p) =>
      p.isPhoneFullHeight ? '0' : p.borderRadius ? p.borderRadius : 0}px;
    min-height: ${(p) =>
      p.isPhoneFullHeight
        ? '100%'
        : typeof p.height === 'number'
        ? `${p.height}px`
        : p.height || 'auto'};
  }
`;

export const ModalBody = styled.div<{
  $headerMediaQuery?: string;
  modalBodyHeight?: string;
  showMarginTop?: boolean;
  reservationTour?: boolean;
}>`
  width: 100%;
  margin-top: ${(p) => (p.showMarginTop ? '10px' : '0px')};
  overflow: ${(reservationTour) => (reservationTour ? 'unset' : 'auto')};
  height: ${(p) => p.modalBodyHeight ?? 'auto'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex: 1;
    padding: 0px;
  }
`;

export const CloseButton = styled.div<{
  $headerMediaQuery?: string;
  $closeElementCss?: ReturnType<typeof css>;
  warning?: boolean;
}>`
  margin-top: ${(p) => (p.warning ? '30px' : '0px')};
  width: 24px;
  height: 24px;
  cursor: pointer;
  margin-left: auto;
  position: relative;
  ${(p) => p.$closeElementCss ?? css``}
`;

export const ModalTitle = styled.div`
  font-size: 24px;
  font-weight: 600px;
  line-height: 22px;
  width: 100%;
  height: 100%;
`;
export const ModalHeader = styled.div<{
  $headerMediaQuery?: string;
  $headerElementCss?: ReturnType<typeof css>;
  headerHeight?: string;
}>`
  width: 100%;
  height: ${(p) => (p.headerHeight ? `${p.headerHeight}` : '24px')};
  display: flex;
  padding-bottom: 10px;
  ${(p) => p.$headerElementCss ?? css``}
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: ${(p) => (p.headerHeight ? `${p.headerHeight}` : '35px')};
  }
`;
export const Footer = styled.div<{ padding?: SizeUnit }>`
  margin-top: auto;
  margin-left: ${(p) => (p.padding ? `-${p.padding}` : '-40px')};
  margin-bottom: ${(p) => (p.padding ? `-${p.padding}` : '-40px')};
  margin-right: ${(p) => (p.padding ? `-${p.padding}` : '-40px')};
`;
export const CloseButtonContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const CloseButtonLabel = styled.label`
  width: 45px;
  height: 23px;
  margin: 0 10px 1px 0;
  font-size: 18px;
  color: ${(p) => p.theme.palette.darkGrey};
  cursor: pointer;
  font-weight: normal;
`;
